module.exports = __webpack_public_path__ + "static/media/1987_GDP_totalRate.d47a9874.png";